import type { TypeAuthorSkeleton } from './TypeAuthor'
import type { TypeCategorySkeleton } from './TypeCategory'
import type { TypeKeywordSkeleton } from './TypeKeyword'
import type { TypeRegionSkeleton } from './TypeRegion'
import type { TypeVideoFileSkeleton } from './TypeVideoFile'

import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'

export interface TypeStoryFields {
  title: EntryFieldTypes.Symbol
  newsletterTitle?: EntryFieldTypes.Symbol
  slug: EntryFieldTypes.Symbol
  slugValidation?: EntryFieldTypes.Symbol<'true'>
  authors?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeAuthorSkeleton>>
  publishedAt?: EntryFieldTypes.Date
  originalPublishedAt?: EntryFieldTypes.Date
  heroImage?: EntryFieldTypes.AssetLink
  videoFile?: EntryFieldTypes.EntryLink<TypeVideoFileSkeleton>
  thumbnail: EntryFieldTypes.AssetLink
  description: EntryFieldTypes.Text
  newsletterAbstract?: EntryFieldTypes.Symbol
  categories?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeCategorySkeleton>>
  withAds?: EntryFieldTypes.Boolean
  content?: EntryFieldTypes.RichText
  regions?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeRegionSkeleton>>
  keywords?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeKeywordSkeleton>>
  publishToAppleNews: EntryFieldTypes.Boolean
  appleNewsId?: EntryFieldTypes.Object
  appleNewsRevisionId?: EntryFieldTypes.Object
  deletedAt?: EntryFieldTypes.Date
  tmsId?: EntryFieldTypes.Symbol
  airedAt?: EntryFieldTypes.Date
  block?: EntryFieldTypes.Symbol
  captions?: EntryFieldTypes.Object
  clip?: EntryFieldTypes.Boolean
  free?: EntryFieldTypes.Boolean
  indexed?: EntryFieldTypes.Boolean
  contentId?: EntryFieldTypes.Symbol
  cuePoints?: EntryFieldTypes.Symbol
  deleted?: EntryFieldTypes.Boolean
  episodeNumber?: EntryFieldTypes.Integer
  importMetadata?: EntryFieldTypes.Object
  playCount?: EntryFieldTypes.Integer
  thumbnailChecksum?: EntryFieldTypes.Symbol
  transcript?: EntryFieldTypes.Text
  transcriptionId?: EntryFieldTypes.Integer
  transcriptionStatus?: EntryFieldTypes.Symbol
  tweetText?: EntryFieldTypes.Symbol
  thumbnailAttribution?: EntryFieldTypes.Text
  body?: EntryFieldTypes.Object
  withTaboola?: EntryFieldTypes.Boolean
  withPreRoll?: EntryFieldTypes.Boolean
  withDvdPreRoll?: EntryFieldTypes.Boolean
}

export type TypeStorySkeleton = EntrySkeletonType<TypeStoryFields, 'story'>
export type TypeStory<Modifiers extends ChainModifiers, Locales extends LocaleCode> = Entry<
  TypeStorySkeleton,
  Modifiers,
  Locales
>

export function isTypeStory<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>
): entry is TypeStory<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'story'
}
